/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpreviewsamplename3Inputs */

const en_ticketpreviewsamplename3 = /** @type {(inputs: Ticketpreviewsamplename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Last`)
};

const de_ticketpreviewsamplename3 = /** @type {(inputs: Ticketpreviewsamplename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname Nachname`)
};

/**
* | output |
* | --- |
* | "First Last" |
*
* @param {Ticketpreviewsamplename3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpreviewsamplename3 = /** @type {((inputs?: Ticketpreviewsamplename3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpreviewsamplename3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpreviewsamplename3(inputs)
	return de_ticketpreviewsamplename3(inputs)
});
export { ticketpreviewsamplename3 as "ticketPreviewSampleName" }